import 'bootstrap/dist/css/bootstrap.min.css'
import './scss/styles.scss'

import React from 'react'

import Footer from './components/Footer/Footer'
import Header from './components/Header/Header'
import Main from './components/Main/Main'

function App() {
  return (
    <div>
      <Header />
      <div
        role="main"
        className="container-fluid p-0 m-0"
        style={{ background: 'var(--vip-color-bg-subtle, #F5F5F5)' }}
      >
        <div className="container-fluid p-0 m-0">
          <div className="row m-0">
            <section className="col-12 col-lg-8 mx-auto p-0">
              <Main />
            </section>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  )
}

export default App
